var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    {
      staticClass: "header",
      class: {
        opacity: _vm.opacity,
        colored: _vm.colored,
        simple: _vm.simple,
        metamask: _vm.metamask,
      },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "header-inner" }, [
          _c(
            "div",
            { staticClass: "header-left" },
            [
              _c(
                "router-link",
                { staticClass: "logo", attrs: { to: { name: "HomePage" } } },
                [
                  _c("img", {
                    staticClass: "logo-img",
                    attrs: {
                      src: "/public/img/logoLogin.svg",
                      width: "130",
                      height: "33",
                      loading: "lazy",
                      alt: "logo",
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "header-navigation" },
            [
              _vm.isAuthenticated
                ? _c(
                    "span",
                    { staticClass: "login-link", attrs: { id: "login-link" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.toMyProfile.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm.userAvatar
                            ? [
                                _c("img", {
                                  staticClass: "avatar",
                                  attrs: {
                                    src: _vm.userAvatar,
                                    width: "24",
                                    height: "24",
                                    loading: "lazy",
                                    alt: "avatar",
                                  },
                                }),
                              ]
                            : _c(
                                "svg",
                                {
                                  staticClass: "avatar",
                                  attrs: {
                                    width: "28",
                                    height: "27",
                                    viewBox: "0 0 28 27",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M14.0009 26.8709C21.3225 26.8709 27.2713 20.922 27.2713 13.6005C27.2713 6.27894 21.3224 0.330078 14.0009 0.330078C6.67933 0.330078 0.730469 6.27894 0.730469 13.6005C0.730469 20.922 6.67933 26.8709 14.0009 26.8709ZM6.67927 21.9781C8.68579 19.5844 11.2904 18.282 14.0009 18.282C16.7113 18.282 19.316 19.5844 21.3225 21.9781C19.3864 23.7028 16.8169 24.7588 14.0009 24.7588C11.1849 24.7588 8.61527 23.7027 6.67927 21.9781ZM14.0009 2.44208C20.1609 2.44208 25.1593 7.44048 25.1593 13.6005C25.1593 16.17 24.2793 18.5637 22.8009 20.4293C20.372 17.6837 17.3097 16.17 14.0009 16.17C10.692 16.17 7.62967 17.6834 5.20087 20.4293C3.72247 18.5286 2.84247 16.17 2.84247 13.6005C2.84247 7.44048 7.84087 2.44208 14.0009 2.44208Z",
                                      fill: "black",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M14.0009 15.115C16.9576 15.115 19.3513 12.7215 19.3513 9.76453C19.3513 6.80779 16.9578 4.41406 14.0009 4.41406C11.0441 4.41406 8.65039 6.80754 8.65039 9.76453C8.65039 12.7215 11.0441 15.115 14.0009 15.115ZM14.0009 6.52619C15.796 6.52619 17.2393 7.96945 17.2393 9.76459C17.2393 11.5597 15.796 13.003 14.0009 13.003C12.2057 13.003 10.7625 11.5597 10.7625 9.76459C10.7625 8.00459 12.2057 6.52619 14.0009 6.52619Z",
                                      fill: "black",
                                    },
                                  }),
                                ]
                              ),
                          _vm._v(" "),
                          _c("span", { staticClass: "username" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.currentUser.username) +
                                "\n            "
                            ),
                          ]),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.simple
                ? [
                    _vm.isAuthenticated && !_vm.simple
                      ? _c(
                          "Teleport",
                          {
                            attrs: {
                              to: "#coins-mobile",
                              disabled: _vm.teleportDisable,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.currency,
                                    expression: "currency",
                                  },
                                ],
                                staticClass: "coins-wrapper",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "coins pixcoin-icon",
                                    on: {
                                      click: function ($event) {
                                        return _vm.purchaseModalOpen(false)
                                      },
                                    },
                                  },
                                  [
                                    _c("number", {
                                      ref: "pixcoins",
                                      staticClass: "coins-value",
                                      attrs: {
                                        from: _vm.oldPxValue,
                                        to: _vm.newPxValue,
                                        duration: _vm.duration,
                                        delay: _vm.delay,
                                        animationPaused: "",
                                        easing: "Power1.easeOut",
                                      },
                                      on: {
                                        complete: function ($event) {
                                          return _vm.counterAnimation(
                                            "pixcoins"
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.isAuthenticated
                ? _c(
                    "span",
                    { staticClass: "login-link", attrs: { id: "login-link" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.toMyProfile.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "avatar",
                              attrs: {
                                width: "28",
                                height: "27",
                                viewBox: "0 0 28 27",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M14.0009 26.8709C21.3225 26.8709 27.2713 20.922 27.2713 13.6005C27.2713 6.27894 21.3224 0.330078 14.0009 0.330078C6.67933 0.330078 0.730469 6.27894 0.730469 13.6005C0.730469 20.922 6.67933 26.8709 14.0009 26.8709ZM6.67927 21.9781C8.68579 19.5844 11.2904 18.282 14.0009 18.282C16.7113 18.282 19.316 19.5844 21.3225 21.9781C19.3864 23.7028 16.8169 24.7588 14.0009 24.7588C11.1849 24.7588 8.61527 23.7027 6.67927 21.9781ZM14.0009 2.44208C20.1609 2.44208 25.1593 7.44048 25.1593 13.6005C25.1593 16.17 24.2793 18.5637 22.8009 20.4293C20.372 17.6837 17.3097 16.17 14.0009 16.17C10.692 16.17 7.62967 17.6834 5.20087 20.4293C3.72247 18.5286 2.84247 16.17 2.84247 13.6005C2.84247 7.44048 7.84087 2.44208 14.0009 2.44208Z",
                                  fill: "black",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M14.0009 15.115C16.9576 15.115 19.3513 12.7215 19.3513 9.76453C19.3513 6.80779 16.9578 4.41406 14.0009 4.41406C11.0441 4.41406 8.65039 6.80754 8.65039 9.76453C8.65039 12.7215 11.0441 15.115 14.0009 15.115ZM14.0009 6.52619C15.796 6.52619 17.2393 7.96945 17.2393 9.76459C17.2393 11.5597 15.796 13.003 14.0009 13.003C12.2057 13.003 10.7625 11.5597 10.7625 9.76459C10.7625 8.00459 12.2057 6.52619 14.0009 6.52619Z",
                                  fill: "black",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "username" }, [
                            _vm._v(" Login "),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.headerType !== "metamaskTemplate"
                ? _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.opacity,
                          expression: "!opacity",
                        },
                      ],
                      staticClass: "burger",
                      on: { click: _vm.menuToggle },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "29",
                            height: "20",
                            viewBox: "0 0 29 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M2 10H27",
                              stroke: "black",
                              "stroke-width": "3.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M2 2H27",
                              stroke: "black",
                              "stroke-width": "3.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M2 18H27",
                              stroke: "black",
                              "stroke-width": "3.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.purchaseModal
        ? _c("PurchaseModal", {
            attrs: { pixtokens: _vm.pixtokens },
            on: {
              modalClose: _vm.purchaseModalClose,
              currencyUpdateCheck: _vm.currencyUpdateCheck,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.successBuy
        ? _c("SuccessBuyModal", {
            attrs: { data: _vm.successBuyData },
            on: { modalClose: _vm.successBuyModalClose },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }